var _style, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebvalueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300.99 223.19",
    style: {
      enableBackground: "new 0 0 300.99 223.19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000131369431037408465490000012404406817139852422_);}\r\n\t.st2{fill:url(#SVGID_00000075858664893587260830000004318293049404059304_);}\r\n\t.st3{fill:url(#SVGID_00000057142759720996971830000007992660331394702743_);}\r\n\t.st4{fill:url(#SVGID_00000034771381997293147130000011016202557481478588_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.8229,
    y1: 162.1785,
    x2: 207.9646,
    y2: 6.6057
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A96F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009887"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "197.54,70.31 199.07,152.55 177.77,152.63 148.62,99.54 151.69,152.71 130.39,152.8 81.64,70.73  105.5,70.65 132.94,121.69 129.96,70.56 149.31,70.48 177.68,121.52 173.85,70.39  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033354570286261010440000017928336632529090705_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.6185,
    y1: 225.1293,
    x2: 305.7602,
    y2: 69.5565
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A96F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009887"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000033354570286261010440000017928336632529090705_)"
    },
    points: "254.38,69.8 300.99,222.25  133.19,222.93 126.89,202.14 275.17,201.55 234.95,69.88  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029038729705840520820000006018588531690432953_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.3296,
    y1: 108.4342,
    x2: 124.4713,
    y2: -47.1386
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A96F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009887"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000029038729705840520820000006018588531690432953_)"
    },
    points: "167.71,0.26 174.1,21.05  25.82,21.65 66.04,153.31 46.62,153.39 0,0.94  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028283481257274483480000001431740714043205013_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.094,
    y1: 161.7094,
    x2: 207.2357,
    y2: 6.1366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A96F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009887"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000028283481257274483480000001431740714043205013_)"
    },
    points: "71.92,172.65 80.96,202.31  108.83,202.23 115.13,223.02 67.91,223.19 52.5,172.74  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129198822781962588400000001674147415402112385_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.8516,
    y1: 171.8525,
    x2: 222.9933,
    y2: 16.2797
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A96F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009887"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000129198822781962588400000001674147415402112385_)"
    },
    points: "233.07,0 248.5,50.45  229.06,50.53 219.95,20.88 192.17,20.97 185.86,0.17  "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebvalueIcon);
export default __webpack_public_path__ + "static/media/webvalue-icon.7154b191af7bd8b66dd39cfaada18211.svg";
export { ForwardRef as ReactComponent };